/*jshint esversion: 6 */
/*jshint strict: false */

import * as d3 from 'd3';

let data = [];

let colours = ['#FF5F5F', '#FF7761', '#FF8E61', '#FFAE64', '#F4CE2F', '#DAF230', '#98E230', '#39B54A', '#2CDDAE', '#2BCFE0', '#29ABE2'];

function setupGraph() {

    let svg = d3.select(".highest-earning .graph svg");

    svg.selectAll("*").remove();

    svg.attr('width', svg.node().getBoundingClientRect().width);
    svg.attr('height', svg.node().getBoundingClientRect().width / 1.8);

    let margin = {top: 50, right: 50, bottom: 50, left: 50},
        width = +svg.attr("width") - margin.left - margin.right,
        height = +svg.attr("height") - margin.top - margin.bottom,
        g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    let xScale = d3.scaleLinear()
        .domain([0, 11])
        .range([0, width]);

    let yScale = d3.scaleLinear()
        .domain([0, 100])
        .range([height, 0]);

    let xAxis = d3.axisBottom(xScale);

    let yAxis = d3.axisLeft()
        .scale(yScale)
        .ticks(5);

    let tooltip = svg.select(function() { return this.parentNode; })
        .append("div")
        .attr("class", "tooltip")
        .style("opacity", 0);

    var gAxisX = g.append('g')
        .attr('transform', 'translate(0,' + height + ')')
        .attr('class', 'axis axis-x')
        .call(xAxis.tickFormat(function (d) {
            return '#' + d
        }));

    gAxisX.append("text")
        .attr('x', width / 2)
        .attr('y', 30)
        .text("Film Number");

    gAxisX.append("text")
        .attr('x', width / 2)
        .attr('y', 50)
        .text("Hover over the chart to see the individual films");


    g.append('g')
        .attr('class', 'axis axis-y')
        .call(yAxis.tickFormat(function (d) {
            return d + ' M'
        }))
        .append("text")
        .attr('x', -20)
        .attr('y', -20)
        .text("Average Opening Weekend ($)");

    let gData = g.append("g")
        .attr('class', 'data');

    gData.selectAll("path")
        .data(data)
        .enter()
        .append("path")
        .attr("fill", function (d, i) {
            return colours[i];
        })
        .attr('d', function (d, i) {
            let barWidth = (width / data.length) * 0.8;
            let dx = xScale(i) + ((width / data.length) * 0.1);
            let dy = yScale(100 - d.revenueMillions);
            return 'M ' + dx + ' ' + height + ' l ' + (barWidth / 2) + ' -' + dy + ' l ' + (barWidth / 2) + ' ' + dy + ' z';
        })
        .on("mouseover", function (d, i) {
            tooltip.transition()
                .duration(200)
                .style("opacity", .9);
            tooltip.html(getTooltip(d, i + 1))
                .style("left", (d3.event.pageX) + "px")
                .style("top", (d3.event.pageY - 28) + "px");
        })
        .on("mouseout", function (d) {
            tooltip.transition()
                .duration(500)
                .style("opacity", 0);
        });

}

function getTooltip(d, i) {
    return 'Film #' + i + '<br />' + d.revenueText;
}


function populateTable() {

    let table = d3.select(".highest-earning .content-table table tbody");

    let tr = table.selectAll("tr")
        .data(data)
        .enter()
        .append("tr");

    tr.append("td").text(function (d, i) {
        return 'Film ' + (i + 1);
    });

    tr.append("td").text(function (d) {
        return d.revenueText;
    });

}

function loadData(dataDir) {

    d3.csv(dataDir + "highest-earning.csv", function (csvData) {
        csvData.forEach(function (d) {
            d.revenueText = d.revenue;
            d.revenue = d.revenue.replace(/[$,£]+/g, "");
            d.revenueMillions = parseInt(parseInt(d.revenue) / 1000000);
        });

        delete csvData['columns'];
        data = csvData;
        populateTable();
        setupGraph();
    });
}

function init(dataDir) {
    loadData(dataDir);
    window.addEventListener("resize", setupGraph);
}

export {init}


// WEBPACK FOOTER //
// ./highest-earning.js